import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const setCheckoutStartedTime: CheckoutActionCreator = (checkoutStartedTime: number) => ({
  type: actionTypes.CHECKOUT_URGENCY_SET_CHECKOUT_STARTED_TIME,
  checkoutStartedTime,
})
